import React, { useContext } from "react";
import "../css/header.css";
import Togle from "../widget/Togle";
import { Link } from "react-scroll";
import { motion } from "framer-motion";
import { themeContext } from "../context";
import { colors } from "../constants/colors";

export const Header = () => {
  const {
    state: { darkMode },
  } = useContext(themeContext);

  const navItems = [
    { label: "Home", to: "home" },
    { label: "Skills", to: "skills" },
    { label: "Experience", to: "experience" },
    { label: "Portfolio", to: "portfolio" },
    { label: "Contact", to: "contact" },
  ];

  return (
    <header
      className="rectangle"
      style={{
        background: darkMode ? colors.secondary : "rgba(255, 255, 255, 0.82)",
        color: darkMode ? "#ffffff" : colors.primary,
        borderBottom: darkMode
          ? "1px solid rgba(148, 163, 184, 0.16)"
          : "1px solid rgba(73, 177, 82, 0.14)",
        boxShadow: darkMode
          ? "0 12px 30px rgba(2, 6, 23, 0.2)"
          : "0 10px 24px rgba(15, 23, 42, 0.08)",
        transition: "all 0.35s ease",
      }}
    >
      <div className="flex-row-f">
        <div className="header-brand-wrap">
          <div
            className="makite-removebg-preview"
            aria-label="Makite Desta logo"
          />
        </div>

        <nav className="menus" aria-label="Main navigation">
          {navItems.map((item) => (
            <motion.div
              key={item.to}
              className="nav-item-wrap"
              whileHover={{ y: -2, scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: "spring", stiffness: 340, damping: 18 }}
            >
              <Link
                className="nav-link"
                spy
                smooth={true}
                duration={220}
                delay={0}
                to={item.to}
                offset={-90}
                activeClass="active-link"
                isDynamic
              >
                <span className={item.label.toLowerCase()}>{item.label}</span>
              </Link>
            </motion.div>
          ))}
        </nav>

        <div className="img-3">
          <Togle />
        </div>
      </div>
    </header>
  );
};
